import axios from "../BASE_API";
import AuthHeader from "../AuthHeader";

export class RBMyFarmerAPI {
    
  allReserveBunchMyFarmer: any = (data: any) => {
    return axios.post("/reserve-bunch/my-farmer-reserve-list", data, { headers: AuthHeader() });
  };

  filterReserveBunchFarmer: any = (data: any) => {
    return axios.post("/reserve-bunch/search-my-farmer-reserve-list", data, { headers: AuthHeader() });
  };

  getReserveBunchFarmeById: any = (id: number) => {
    return axios.post(`/reserve-bunch/land-wise-details`,{land_id:id},{ headers: AuthHeader() });
  };

}



